// const VISITOR_ID_KEY = "bm_visitor_id_key_unique";

// function generateUUID() {
//   return window.crypto.randomUUID();
// }

// const storeUtmToDB = async (utmDataSet: any) => {
//   try {
//     const auth = useUserStore();

//     const visitorId = localStorage.getItem("VISITOR_ID") || generateUUID();
//     if (!localStorage.getItem("VISITOR_ID")) {
//       saveToLocalStorage(visitorId, "VISITOR_ID");
//     }
//     const dataSet = {
//       unique_visitor_id: visitorId,
//       ...utmDataSet,
//       user_id: auth?.user?.id || null,
//     };

//     const response = await useApiPost("/api/utm-track", {
//       method: "POST",
//       body: {
//         ...dataSet,
//       },
//     });

//     console.log(response);
//   } catch (error) {
//     console.log(error);
//   }
// };

// const saveToLocalStorage = (utmData: any, key: string) => {
//   localStorage.setItem(key, JSON.stringify(utmData));
// };
export default defineNuxtPlugin((nuxtApp) => {
  // const STORAGE_KEY = "utm_updated_data_key_updated";
  // const STORAGE_KEY_2 = "utm_first_load_key_updated";
  // const STORAGE_KEY_3 = "utm_user_updated";

  // const { setUtmData, setItmUser } = useUserStore();
  // const getQueryParams = () => {
  //   if (process.client) {
  //     const urlParams = new URLSearchParams(window.location.search);
  //     return {
  //       utm_source: urlParams.get("utm_source") || null,
  //       utm_medium: urlParams.get("utm_medium") || null,
  //       utm_campaign: urlParams.get("utm_campaign") || null,
  //       utm_content: urlParams.get("utm_content") || null,
  //       utm_term: urlParams.get("utm_term") || null,
  //       utm_id: urlParams.get("utm_id") || null,
  //       utm_campaign_id: urlParams.get("utm_campaign_id") || null,
  //       utm_source_platform: urlParams.get("utm_source_platform") || null,
  //       utm_creative_format: urlParams.get("utm_creative_format") || null,
  //       utm_marketing_tactic: urlParams.get("utm_marketing_tactic") || null,
  //     };
  //   }
  //   return {};
  // };

  // function hasUtmParams() {
  //   const params = new URLSearchParams(window.location.search);
  //   return [...params.keys()].some((key) => key.startsWith("utm_"));
  // }

  // const hasUtm = hasUtmParams();
  // if (hasUtm) {
  //   localStorage.setItem(STORAGE_KEY_3, "true");
  // }

  // const getStoredUTM = () => {
  //   if (process.client) {
  //     const storedData = localStorage.getItem(STORAGE_KEY);
  //     const isFirstLoad = localStorage.getItem(STORAGE_KEY_2);
  //     if (!isFirstLoad && storedData === null && hasUtm) {
  //       localStorage.setItem(STORAGE_KEY_2, "true");
  //     } else if (storedData) {
  //       localStorage.setItem(STORAGE_KEY_2, "false");
  //     }

  //     if (storedData === "undefined") return {};
  //     return storedData ? JSON.parse(storedData) : {};
  //   }
  //   return {};
  // };

  // const saveUTM = (utmData: Record<string, string | null>) => {
  //   if (process.client) {
  //     localStorage.setItem(STORAGE_KEY, JSON.stringify(utmData));
  //   }
  // };
  // const updateUTM = () => {
  //   const currentUTM = getQueryParams();
  //   const storedUTM = getStoredUTM();
  //   const isFirstLoad =
  //     localStorage.getItem(STORAGE_KEY_2) === "true" ? true : false;

  //   const isItm = localStorage.getItem(STORAGE_KEY_3) === "true" ? true : false;
  //   let updatedUTM = {
  //     initial_utm_source: storedUTM.initial_utm_source || currentUTM.utm_source,
  //     initial_utm_medium: storedUTM.initial_utm_medium || currentUTM.utm_medium,
  //     initial_utm_campaign:
  //       storedUTM.initial_utm_campaign || currentUTM.utm_campaign,
  //     initial_utm_content:
  //       storedUTM.initial_utm_content || currentUTM.utm_content,
  //     initial_utm_term: storedUTM.initial_utm_term || currentUTM.utm_term,
  //     initial_utm_id: storedUTM.initial_utm_id || currentUTM.utm_id,
  //     initial_utm_campaign_id:
  //       storedUTM.initial_utm_campaign_id || currentUTM.utm_campaign_id,
  //     initial_utm_source_platform:
  //       storedUTM.initial_utm_source_platform || currentUTM.utm_source_platform,
  //     initial_utm_creative_format:
  //       storedUTM.initial_utm_creative_format || currentUTM.utm_creative_format,
  //     initial_utm_marketing_tactic:
  //       storedUTM.initial_utm_marketing_tactic ||
  //       currentUTM.utm_marketing_tactic,

  //     utm_source: currentUTM.utm_source || storedUTM.utm_source || null,
  //     utm_medium: currentUTM.utm_medium || storedUTM.utm_medium || null,
  //     utm_campaign: currentUTM.utm_campaign || storedUTM.utm_campaign || null,
  //     utm_content: currentUTM.utm_content || storedUTM.utm_content || null,
  //     utm_term: currentUTM.utm_term || storedUTM.utm_term || null,
  //     utm_id: currentUTM.utm_id || storedUTM.utm_id || null,
  //     utm_campaign_id:
  //       currentUTM.utm_campaign_id || storedUTM.utm_campaign_id || null,
  //     utm_source_platform:
  //       currentUTM.utm_source_platform || storedUTM.utm_source_platform || null,
  //     utm_creative_format:
  //       currentUTM.utm_creative_format || storedUTM.utm_creative_format || null,
  //     utm_marketing_tactic:
  //       currentUTM.utm_marketing_tactic ||
  //       storedUTM.utm_marketing_tactic ||
  //       null,
  //   };
  //   setUtmData({ ...updatedUTM, utm_first_load: Boolean(isFirstLoad) });
  //   if (hasUtm) {
  //     saveUTM(updatedUTM);
  //     storeUtmToDB(updatedUTM);
  //   }
  //   if (Boolean(isItm)) {
  //     setItmUser(true);
  //   }
  // };

  // updateUTM();
});
